import { render, staticRenderFns } from "./ReceptionPatientDialogSelector.vue?vue&type=template&id=1ea5c2c9&scoped=true&"
import script from "./ReceptionPatientDialogSelector.vue?vue&type=script&lang=ts&"
export * from "./ReceptionPatientDialogSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionPatientDialogSelector.vue?vue&type=style&index=0&id=1ea5c2c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5c2c9",
  null
  
)

export default component.exports